import { rtkqApi } from "../api/rtkqApi";

export interface ICountry {
  name: string;
  id: string;
  code: string;
  tel_codes: ICode[];
}

export interface ICode {
  tel_code: string;
  tel_mask?: string;
}

/**
 * TODO: Заменить эндпоинт на новый эндпоинт Foundation
 */
export const phoneCodesApi = rtkqApi.injectEndpoints({
  endpoints: builder => ({
    getPhoneCodes: builder.query<ICountry[], void>({
      query: () => ({
        url: "/pages/countriez_phones/",
        method: "POST",
        params: { gu_ajax: true },
      }),
      transformResponse: (response: { countriez: ICountry[] }) =>
        response.countriez,
    }),
  }),
});
